const LAZY_ROUTE_RELOAD_PREFIX = "tb_lazy_route_reload_v1:";

export function lazyRouteReloadKey(routeKey) {
  const normalized = String(routeKey || "route")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return `${LAZY_ROUTE_RELOAD_PREFIX}${normalized || "route"}`;
}

export function isLazyRouteLoadError(error) {
  const name = String(error?.name || "");
  const message = String(error?.message || error || "");
  return (
    name === "ChunkLoadError" ||
    /failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message) ||
    /loading (?:css )?chunk [^\s]+ failed/i.test(message) ||
    /unable to preload css/i.test(message)
  );
}

export function claimLazyRouteReload(storage, routeKey) {
  if (!storage) return false;
  try {
    const key = lazyRouteReloadKey(routeKey);
    if (storage.getItem(key) === "1") return false;
    storage.setItem(key, "1");
    return true;
  } catch {
    return false;
  }
}

export function clearLazyRouteReload(storage, routeKey) {
  if (!storage) return;
  try {
    storage.removeItem(lazyRouteReloadKey(routeKey));
  } catch {
    // Storage can be unavailable in hardened/private browser modes.
  }
}
